import React from 'react';
import styled from 'styled-components';
import FinalForm from './FinalForm';
import RiskScores from './RiskScores';
import { SideBySide } from './Outlook';
import { AppContext } from '../App';
import { breakpoints } from '../styles/utilities/settings';

const PestScores = () => (
  <AppContext.Consumer>
    {value => (
      <SPestScores>
        <SideBySide>
          <RiskScores
            data={value.csvData}
            zipCode={value.userZip}
            industry={value.userIndustry}
          />
          <FinalForm />
        </SideBySide>
      </SPestScores>
    )}
  </AppContext.Consumer>
);

export default PestScores;

const SPestScores = styled.div`
  position: relative;
  padding-top: 20px;

  h2 {
    text-align: left;
  }

  ${SideBySide} {
    > div {
      &:nth-child(1) {

        @media screen and (min-width: ${breakpoints.ipadPort}px) {
          width: 60%;
          max-width: none;
        }
      }

      &:nth-child(2) {
        padding: 0;

        @media screen and (min-width: ${breakpoints.ipadPort}px) {
          width: 40%;
          max-width: 445px;
        }
      }
    }
  }
`;
